module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tabs', {
    attrs: {
      "nav-style": "tabs"
    },
    model: {
      value: (_vm.activeTabIndex),
      callback: function($$v) {
        _vm.activeTabIndex = $$v
      },
      expression: "activeTabIndex"
    }
  }, [_c('tab', {
    attrs: {
      "header": "PA"
    }
  }, [_c('h3', [_vm._v("PA")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [(_vm.loading) ? _c('loader') : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('form', {
    staticClass: "form form-horizontal",
    attrs: {
      "data-vv-scope": "pa"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("DB Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.pa.dbnumber))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('pa.paName')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("PA Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pa.paName),
      expression: "pa.paName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "paName",
      "aria-required": "true",
      "disabled": !_vm.isPrimaryUser
    },
    domProps: {
      "value": (_vm.pa.paName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pa, "paName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pa.paName') && _vm.pa.paName.length === 0),
      expression: "errors.has('pa.paName') && pa.paName.length === 0"
    }],
    staticClass: "has-error"
  }, [_vm._v("PA Name\n                            is required")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pa.paName') && _vm.pa.paName.length > 255),
      expression: "errors.has('pa.paName') && pa.paName.length > 255"
    }],
    staticClass: "has-error"
  }, [_vm._v("PA Name\n                            cannot be longer than 255 characters")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Responsible Federal Agency")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAgencyId),
      expression: "selectedAgencyId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "agencyId",
      "disabled": !_vm.isPrimaryUser
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAgencyId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.agencyOrgList), function(blm) {
    return _c('option', {
      key: blm.id,
      domProps: {
        "value": blm.id
      }
    }, [_vm._v(_vm._s(blm.description) + "\n                            ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedLeadAgency && _vm.selectedLeadAgency.hasUsers === false && !_vm.selectedLeadAgency.agencyNoReview),
      expression: "selectedLeadAgency && selectedLeadAgency.hasUsers === false && !selectedLeadAgency.agencyNoReview"
    }],
    staticClass: "has-error"
  }, [_vm._v("\n                            Selected Federal Agency has no Wyotrack users\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Secondary Federal Agencies")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('v-select', {
    staticStyle: {
      "background-color": "#fafafa"
    },
    attrs: {
      "options": _vm.agencyOrgList,
      "name": "secondaryAgencyIds",
      "label": "description",
      "multiple": "",
      "disabled": !_vm.isPrimaryUser
    },
    model: {
      value: (_vm.secondaryAgencyOrgs),
      callback: function($$v) {
        _vm.secondaryAgencyOrgs = $$v
      },
      expression: "secondaryAgencyOrgs"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('pa.agencyNo')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Agency Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pa.agencyNo),
      expression: "pa.agencyNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:255'),
      expression: "'max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "agencyNo",
      "disabled": !_vm.isPrimaryUser
    },
    domProps: {
      "value": (_vm.pa.agencyNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pa, "agencyNo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pa.agencyNo')),
      expression: "errors.has('pa.agencyNo')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Agency Number cannot be longer\n                            than 255 characters")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Effective Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "MM/dd/yyyy",
      "placeholder": "Select Effective Date",
      "disabled": !_vm.isPrimaryUser && !_vm.isSecondaryUser
    },
    model: {
      value: (_vm.pa.effectiveDate),
      callback: function($$v) {
        _vm.$set(_vm.pa, "effectiveDate", $$v)
      },
      expression: "pa.effectiveDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Stipulations")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(!_vm.isUnknownUser) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "name": "addStipulation",
      "disabled": !_vm.pa.paId || (!_vm.isPrimaryUser && !_vm.isSecondaryUser)
    },
    on: {
      "click": function($event) {
        _vm.createNewStipulation()
      }
    }
  }, [_vm._v("Add Stipulation")]) : _vm._e(), _vm._v(" "), _c('v-client-table', {
    ref: "stipulationTable",
    attrs: {
      "data": _vm.stipGridSpec.tableData,
      "columns": _vm.stipGridSpec.columns,
      "options": _vm.stipGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return [(!_vm.isUnknownUser) ? _c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.$refs['stipulation' + props.index][0].open()
            }
          }
        })]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _vm._l((_vm.pa.paStipulationList), function(stipulation, index) {
    return _c('modal', {
      key: index,
      ref: 'stipulation' + index,
      refInFor: true
    }, [_c('div', {
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('h3', {
      staticClass: "pull-left"
    }, [_vm._v("Stipulation")])]), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "body"
      },
      slot: "body"
    }, [_c('div', {}, [_c('form', {
      staticClass: "form form-horizontal",
      attrs: {
        "data-vv-scope": "stipulation"
      },
      on: {
        "submit": function($event) {
          $event.preventDefault();
        }
      }
    }, [_c('div', {
      staticClass: "form-group",
      class: {
        'has-error': _vm.errors.has('stipulation.stipHeading')
      }
    }, [_c('label', {
      staticClass: "col-xs-3 control-label"
    }, [_vm._v("Stipulation Heading")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (stipulation.stipulationHeading),
        expression: "stipulation.stipulationHeading"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "name": "stipHeading",
        "aria-required": "true"
      },
      domProps: {
        "value": (stipulation.stipulationHeading)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(stipulation, "stipulationHeading", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('stipulation.stipHeading')),
        expression: "errors.has('stipulation.stipHeading')"
      }],
      staticClass: "has-error"
    }, [_vm._v("Stipulation Heading is required")])])]), _vm._v(" "), _c('div', {
      staticClass: "form-group",
      class: {
        'has-error': _vm.errors.has('stipulation.stipDescription')
      }
    }, [_c('label', {
      staticClass: "col-xs-3 control-label"
    }, [_vm._v("Stipulation Description")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (stipulation.stipulationDescription),
        expression: "stipulation.stipulationDescription"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control",
      attrs: {
        "name": "stipDescription",
        "rows": "5",
        "aria-required": "true"
      },
      domProps: {
        "value": (stipulation.stipulationDescription)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(stipulation, "stipulationDescription", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('stipulation.stipDescription')),
        expression: "errors.has('stipulation.stipDescription')"
      }],
      staticClass: "has-error"
    }, [_vm._v("Stipulation Description is required")])])]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-xs-3 control-label"
    }, [_vm._v("Has Due Date")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (stipulation.hasDueDate),
        expression: "stipulation.hasDueDate"
      }],
      attrs: {
        "id": 'dueDate' + index,
        "type": "checkbox",
        "name": "hasDueDate"
      },
      domProps: {
        "checked": Array.isArray(stipulation.hasDueDate) ? _vm._i(stipulation.hasDueDate, null) > -1 : (stipulation.hasDueDate)
      },
      on: {
        "change": function($event) {
          var $$a = stipulation.hasDueDate,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (stipulation.hasDueDate = $$a.concat([$$v]))
            } else {
              $$i > -1 && (stipulation.hasDueDate = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(stipulation, "hasDueDate", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'dueDate' + index
      }
    })])])]), _vm._v(" "), (stipulation.hasDueDate) ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-xs-3 control-label"
    }, [_vm._v("Due Date")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6"
    }, [_c('el-date-picker', {
      attrs: {
        "type": "date",
        "format": "MM/dd/yyyy",
        "placeholder": "Select Due Date"
      },
      model: {
        value: (stipulation.dueDate),
        callback: function($$v) {
          _vm.$set(stipulation, "dueDate", $$v)
        },
        expression: "stipulation.dueDate"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-xs-3 control-label"
    }, [_vm._v("Complete Date")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6"
    }, [_c('el-date-picker', {
      attrs: {
        "type": "date",
        "format": "MM/dd/yyyy",
        "placeholder": "Select Complete Date"
      },
      model: {
        value: (stipulation.completeDate),
        callback: function($$v) {
          _vm.$set(stipulation, "completeDate", $$v)
        },
        expression: "stipulation.completeDate"
      }
    })], 1)])])])]), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('div', {}, [_c('button', {
      staticClass: "btn btn-primary col-xs-5",
      attrs: {
        "type": "button",
        "name": "close"
      },
      on: {
        "click": function($event) {
          _vm.validateStipulation(index)
        }
      }
    }, [_vm._v("Finish Editing and Close")])])])])
  }), _vm._v(" "), _c('modal', {
    ref: "newStipulationModal"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v("Stipulation")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    on: {
      "click": function($event) {
        _vm.$refs['newStipulationModal'].close()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {}, [_c('form', {
    staticClass: "form form-horizontal",
    attrs: {
      "data-vv-scope": "stipulationNew"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('stipulationNew.stipHeading')
    }
  }, [_c('label', {
    staticClass: "col-xs-3 control-label"
  }, [_vm._v("Stipulation Heading")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStipulation.stipulationHeading),
      expression: "newStipulation.stipulationHeading"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "stipHeading",
      "aria-required": "true"
    },
    domProps: {
      "value": (_vm.newStipulation.stipulationHeading)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStipulation, "stipulationHeading", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('stipulationNew.stipHeading')),
      expression: "errors.has('stipulationNew.stipHeading')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Stipulation Heading is required")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('stipulationNew.stipDescription')
    }
  }, [_c('label', {
    staticClass: "col-xs-3 control-label"
  }, [_vm._v("Stipulation Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStipulation.stipulationDescription),
      expression: "newStipulation.stipulationDescription"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "stipDescription",
      "rows": "5",
      "aria-required": "true"
    },
    domProps: {
      "value": (_vm.newStipulation.stipulationDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStipulation, "stipulationDescription", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('stipulationNew.stipDescription')),
      expression: "errors.has('stipulationNew.stipDescription')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Stipulation Description is required")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-3 control-label"
  }, [_vm._v("Has Due Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStipulation.hasDueDate),
      expression: "newStipulation.hasDueDate"
    }],
    attrs: {
      "id": "hasDueDateNew",
      "type": "checkbox",
      "name": "hasDueDate"
    },
    domProps: {
      "checked": Array.isArray(_vm.newStipulation.hasDueDate) ? _vm._i(_vm.newStipulation.hasDueDate, null) > -1 : (_vm.newStipulation.hasDueDate)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newStipulation.hasDueDate,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newStipulation.hasDueDate = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newStipulation.hasDueDate = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.newStipulation, "hasDueDate", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "hasDueDateNew"
    }
  })])])]), _vm._v(" "), (_vm.newStipulation.hasDueDate) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-3 control-label"
  }, [_vm._v("Due Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "MM/dd/yyyy",
      "placeholder": "Select Due Date"
    },
    model: {
      value: (_vm.newStipulation.dueDate),
      callback: function($$v) {
        _vm.$set(_vm.newStipulation, "dueDate", $$v)
      },
      expression: "newStipulation.dueDate"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-3 control-label"
  }, [_vm._v("Complete Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "MM/dd/yyyy",
      "placeholder": "Select Complete Date"
    },
    model: {
      value: (_vm.newStipulation.completeDate),
      callback: function($$v) {
        _vm.$set(_vm.newStipulation, "completeDate", $$v)
      },
      expression: "newStipulation.completeDate"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {}, [_c('button', {
    staticClass: "btn btn-primary col-xs-5",
    attrs: {
      "type": "button",
      "name": "close"
    },
    on: {
      "click": _vm.saveNewStipulation
    }
  }, [_vm._v("Finish Creating and Close")])])])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Undertaking")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(!_vm.isUnknownUser) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "name": "assignUndertaking",
      "disabled": !_vm.pa.paId || (!_vm.isPrimaryUser && !_vm.isSecondaryUser)
    },
    on: {
      "click": function($event) {
        _vm.$refs['undertakingAssignModal'].open()
      }
    }
  }, [_vm._v("Assign Undertaking")]) : _vm._e(), _vm._v(" "), _c('v-client-table', {
    ref: "undertakingTable",
    attrs: {
      "data": _vm.utGridSpec.tableData,
      "columns": _vm.utGridSpec.columns,
      "options": _vm.utGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return !_vm.isUnknownUser ? [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "16px"
          },
          attrs: {
            "to": {
              path: '/Undertaking/' + props.row.undertakingId
            },
            "tag": "a"
          }
        })], 1)] : undefined
      }
    }, {
      key: "remove",
      fn: function(props) {
        return !_vm.isUnknownUser ? [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('button', {
          staticClass: "btn",
          on: {
            "click": function($event) {
              _vm.removeUndertaking(props.row.undertakingId)
            }
          }
        }, [_vm._v("Remove")])])] : undefined
      }
    }])
  }), _vm._v(" "), _c('modal', {
    ref: "undertakingAssignModal"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v("Assign Undertaking")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    on: {
      "click": function($event) {
        _vm.$refs['undertakingAssignModal'].close()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('h4', [_vm._v("Search Undertaking")]), _vm._v(" "), _c('div', {}, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.loadData($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    attrs: {
      "for": "searchDbNumber"
    }
  }, [_vm._v("DB Number")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.utSearchDto.dbNumber),
      expression: "utSearchDto.dbNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "searchDbNumber"
    },
    domProps: {
      "value": (_vm.utSearchDto.dbNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.utSearchDto, "dbNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-sm-offset-1"
  }, [_c('label', {
    attrs: {
      "for": "searchName"
    }
  }, [_vm._v("Name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.utSearchDto.name),
      expression: "utSearchDto.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "searchName"
    },
    domProps: {
      "value": (_vm.utSearchDto.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.utSearchDto, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    attrs: {
      "for": "searchAgnecyNo"
    }
  }, [_vm._v("Agency Number")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.utSearchDto.agencyNumber),
      expression: "utSearchDto.agencyNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "searchAgnecyNo"
    },
    domProps: {
      "value": (_vm.utSearchDto.agencyNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.utSearchDto, "agencyNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.loadUnassignedUndertakings()
      }
    }
  }, [_vm._v("Search")])])])])]), _vm._v(" "), _c('div', {}, [_c('v-client-table', {
    attrs: {
      "data": _vm.utAllGridSpec.tableData,
      "columns": _vm.utAllGridSpec.columns,
      "options": _vm.utAllGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "assign",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('button', {
          staticClass: "btn",
          on: {
            "click": function($event) {
              _vm.assignUndertaking(props.row.undertakingId)
            }
          }
        }, [_vm._v("Assign")])])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {}, [_c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "type": "button",
      "name": "cancel"
    },
    on: {
      "click": function($event) {
        _vm.$refs['undertakingAssignModal'].close()
      }
    }
  }, [_vm._v("Close")])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('validationResultDisplay', {
    attrs: {
      "validationResult": _vm.validationResult
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(!_vm.isUnknownUser) ? _c('div', {
    staticClass: "col-md-offset-2"
  }, [_c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "submit",
      "name": "submit"
    },
    on: {
      "click": _vm.savePa
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.paId ? 'Save' : 'Create') + "\n                        ")])]) : _vm._e()])]) : _vm._e()], 1)]), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Documents"
    }
  }, [(_vm.$route.params.paId) ? _c('moaPaDocuments', {
    ref: "paDocuments",
    attrs: {
      "paId": _vm.$route.params.paId,
      "loadOnMount": false
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('hr'), _vm._v(" "), _c('mediaLetter', {
    ref: "mediaLetter",
    attrs: {
      "mediaTypeId": _vm.mediaTypeIdPaLetter,
      "parentId": _vm.paId,
      "loadOnMount": false
    }
  })], 1)], 1), _vm._v(" "), (_vm.$route.params.paId && _vm.isPrimaryUser) ? _c('tab', {
    attrs: {
      "header": "Workflow",
      "disabled": !_vm.$route.params.paId || !_vm.isPrimaryUser
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('workflow', {
    ref: "workflow",
    attrs: {
      "workflowId": _vm.paWorkflowId,
      "parentId": _vm.paId
    },
    on: {
      "workflowOnSubmitSuccess": _vm.workflowOnSubmitSuccess
    }
  })], 1), _vm._v(" "), (_vm.checkShpoRole) ? _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('quickLetter', {
    attrs: {
      "paId": _vm.paId,
      "mediaTypeId": _vm.mediaTypeIdPaLetter,
      "parentId": _vm.paId
    }
  })], 1) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43917214"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Pa.vue
// module id = 929
// module chunks = 1